import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

import { StyledSwitcherType, SwitcherType } from "./types";

// CRM's components/themeSwitcher/switcher/Switcher.tsx: a pill toggle with the
// sun/moon icomoon glyphs cross-fading over the track.
export const Switcher = ({ defaultValue, className, onToggle }: SwitcherType) => {
  const [isActive, setIsActive] = useState(defaultValue);

  useEffect(() => {
    setIsActive(defaultValue);
  }, [defaultValue]);

  const toggle = () => {
    onToggle(!isActive);
    setIsActive(!isActive);
  };

  return (
    <Container onClick={toggle} className={className}>
      <Toggle $isActive={isActive} />
      <SunIcon $isActive={isActive} className="icon-ic-sun" />
      <MoonIcon $isActive={isActive} className="icon-ic-moon" />
    </Container>
  );
};

export default Switcher;

const iconCss = css<StyledSwitcherType>`
  position: absolute;
  font-style: normal;
  line-height: 1;
  font-size: 16px;
  transition: opacity 0.15s ease-in-out;
  color: ${({ theme }) => theme.colors.fg.white};
  pointer-events: none;
`;

const MoonIcon = styled.i<StyledSwitcherType>`
  ${iconCss};
  right: 3px;
  opacity: ${({ $isActive }) => ($isActive ? 0 : 1)};
`;

const SunIcon = styled.i<StyledSwitcherType>`
  ${iconCss};
  left: 3px;
  font-size: 15px;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
`;

const Container = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const Toggle = styled.div<StyledSwitcherType>`
  box-sizing: border-box;
  position: relative;
  width: 45px;
  height: 24px;
  background: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.fg.orange : theme.colors.fg.accent};
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    box-sizing: border-box;
    content: "";
    position: absolute;
    top: 50%;
    left: 4px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.fg.white};
    transition: 300ms all;
    transform: ${({ $isActive }) => ($isActive ? "translate(21px, -50%)" : "translate(0, -50%)")};
  }
`;
